module.exports = __webpack_public_path__ + "img/facebook.794fd622.png";